export default ({ app, i18n }, inject) => {
  const getMetaTags = (seo) => {
    return {
      title: seo?.title || 'Les Dix Vins',
      meta: [
        {
          name: 'description',
          content: seo?.description,
        },
        {
          property: 'og:image',
          content: seo?.image,
        },
        {
          name: 'keywords',
          content: seo?.keywords,
        },
        // Metatags para Twitter
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:title',
          content: seo?.title || 'Les Dix Vins',
        },
        {
          name: 'twitter:description',
          content: seo?.description,
        },
        {
          name: 'twitter:image',
          content: seo?.image,
        },
        // Metatags para Facebook
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:site_name',
          content: process.env.VUE_APP_TITLE,
        },
        {
          property: 'og:title',
          content: seo?.title || 'Les Dix Vins',
        },
        {
          property: 'og:description',
          content: seo?.description,
        },
        {
          property: 'og:image',
          content: seo?.image,
        },
      ],
    }
  }

  // Inyectar en el contexto de la aplicación
  if (app) {
    app.getMetaTags = getMetaTags
  }

  // Inyectar en el contexto de Vue
  inject('getMetaTags', getMetaTags)

  // Inyectar en el contexto de Nuxt para asyncData
  if (app.context) {
    app.context.$getMetaTags = getMetaTags
  }
}
